<div class="jumbotron">
  <div class="container">
    <br>
      <div class="row">
        <div class="col-sm-12 table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th>#</th>
                <th>Date</th>
                <th colspan="2">Patient</th>
                <!-- <th>Service</th> -->
                <th>Amount</th>
                <th>Type</th>
                <!-- <th>Package</th> -->
                <th></th>
              </tr>
            </thead>
            <tbody>
              @if (list_length == 0) {
                <tr>
                  <td colspan="9">No data found</td>
                </tr>
              }
              @for (item of items; track item; let i = $index) {
                <tr>
                  <td>{{((filter_config.currentPage - 1) * filter_config.itemsPerPage) + (i+1)}}</td>
                  <td>{{item.date | date:'dd/MM/yyyy hh:mm a' }}</td>
                  <td>{{item.payment_details?.patient?.patient_number }}</td>
                  <td>{{item.payment_details?.patient?.patient_name }}</td>
                  <!-- <td>{{item.payment_details?.payment_services?.service_name }}</td> -->
                  <td>{{item.final_price | number }}</td>
                  <td>{{item.payment_type }}</td>
                  <!-- <td>{{item.payment_package }}</td> -->
                  <td>
                    <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group"
                      dir="auto">
                      <a target="_blank" class="btn btn-info" (click)="open_invoice(item.id)">
                        <svg width="16px" height="16px" viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#ffffff">
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g id="SVGRepo_tracerCarrier" stroke-linecap="round"
                          stroke-linejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path stroke="#ffffff" stroke-linejoin="round" stroke-width="2"
                              d="M8 17H5a1 1 0 01-1-1v-5a2 2 0 012-2h12a2 2 0 012 2v5a1 1 0 01-1 1h-3M8 4h8v5H8V4zm0 11h8v4H8v-4z">
                            </path>
                            <circle cx="7" cy="12" r="1" fill="#ffffff"></circle>
                          </g>
                        </svg>
                      </a>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-paginator #paginator showFirstLastButtons [length]="filter_config.totalItems"
            [pageSize]="filter_config.itemsPerPage" [pageSizeOptions]="filter_config.pageSizeOptions"
            (page)="pageChangeEvent($event)">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>